<template>
  <div>
    <ListingLayout
      :is-loading="isLoading"
      :meta="meta"
      :headers="_headers"
      :items="dummyData"
      selected-product="cso"
      :product-options="productOptions"
      show-date
      :filter-names="filterNames"
      search-label="search"
      :show-data-table="false"
      @filterOption="onFiltersChange"
    >
      <!-- add Filters -->
      <!-- <template #addFilters> </template> -->

      <template #description>
        <div>
          <energy-boxes />
        </div>
      </template>

      <!-- add Filters -->
      <template #moreFilters>
        <div>
          <refresh-button
            :is-loading="isLoading"
            @reload="fetchData"
          />
        </div>
      </template>
      <!-- Action Modals -->
      <template #actionModals>
        <div />
      </template>
      <!-- Action Modals -->
    </ListingLayout>
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { mapGetters } from "vuex";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    refreshButton: () => import("@/components/base/RefreshButton.vue"),
    EnergyBoxes: () => import("./utils/EnergyBoxes.vue"),
  },
  mixins: [ListingLayoutMixins],

  data() {
    return {
      productOptions: [
        { id: "oem", value: "OEM" },
        { id: "cso", value: "CSO" },
      ],
      permissions: {
        view: "energy-analyzer.view",
        create: "energy-analyzer.create",
        edit: "energy-analyzer.edit",
        delete: "energy-analyzer.delete",
      },
      filters: {},
      subFilters: {},
      //
      customFilters: {},
      //
      dummyData: [
        {
          ticket_id: "EV-9401",
          tenant_name: "Tenant A",
          station_name: "Station 1",
          issue: "Total Power Loss - Main Circuit",
          severity: "R1(24H SLA)",
          time_remaining: "12H 30M",
          status: "Breached",
        },
        {
          ticket_id: "EV-9402",
          tenant_name: "Tenant B",
          station_name: "Station 2",
          issue: "Connector Interlock Failure",
          severity: "R1(24H SLA)",
          time_remaining: "03H 30M",
          status: "Escalated",
        },
        {
          ticket_id: "EV-9403",
          tenant_name: "Tenant C",
          station_name: "Station 3",
          issue: "Payment Module Error",
          severity: "R2(48H SLA)",
          time_remaining: "24H 00M",
          status: "In Progress",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "energyAnalyzer/getLoading",
      meta: "energyAnalyzer/getMeta",
      list: "energyAnalyzer/getDashboardData",
      //
    }),
    _headers() {
      const headers = [
        {
          text: "Ticket ID",
          align: "left",
          sortable: false,
          value: "ticket_id",
        },
        {
          text: this.$t("tenant_name"),
          align: "left",
          sortable: false,
          value: "tenant_name",
          showAdmin: true,
        },
        {
          text: "Station",
          align: "left",
          sortable: false,
          value: "station_name",
        },

        {
          text: "Issue",
          align: "left",
          sortable: false,
          value: "issue",
        },

        {
          text: this.$t("severity"),
          align: "center",
          sortable: false,
          value: "severity",
        },
        {
          text: "Time Remaining",
          align: "center",
          sortable: false,
          value: "time_remaining",
        },
        {
          text: this.$t("status"),
          align: "left",
          sortable: false,
          value: "status",
        },
        ...(this.isView || this.isEdit || this.isDelete
          ? [
              {
                text: this.$t("actions"),
                align: "left",
                sortable: false,
                value: "actions",
              },
            ]
          : []),
      ];

      // computed headers for showing columns to role based
      return headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },

    filterNames() {
      return ["search", "locations", "charge_point"];
    },
  },
  watch: {
    options() {
      this.fetchData();
    },
  },
  async mounted() {},
  beforeDestroy() {
    const params = {
      name: "energy_analyzer_and_efficiency",
      filters: { ...this.options, ...this.customFilters },
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  methods: {
    async fetchData() {
      const params = { ...this.options, ...this.customFilters };

      await this.$store
        .dispatch("energyAnalyzer/dashboard", params)
        .then(() => {
          if (this.options.page > (this.meta?.lastPage || 1)) {
            this.options.page = 1;
          }
        });
    },
    //
  },
};
</script>
<style scoped>
.row-box-wrap {
  display: flex;
  align-items: center;
  margin: 8px 0;
  gap: 10px;
  /* Adds space between items */
}

.text-muted {
  color: #6c757d;
}

.highlighted {
  font-weight: bold;
}

.copy-button {
  margin-left: auto;
  /* Pushes the button to the far right */
}
</style>
